import Card from './Card.tsx'
import Fetchdatos from './Fetchdatos'
import CardHistoryItem from './progreso/Cardhistoryitem.js'
import './cards.css' 
import React, { useState, useEffect , memo} from 'react';
import Loader from './LoaderSumaq.js';


import PDFGrid from './pdfcomp/PDFGrid.jsx';
import HeaderResults from './imgBackground/HeaderResults.jsx';

import CardGrid from './cardscomp/CardGrid.jsx';

import LegendaTemperatureLecture from './elements/LegendaTemperatureLecture.jsx';
import LectureCategorySelector from './elements/LectureCategorySelector.jsx';

import PinterestEmbed from './socialnetwork/PinterestEmbed.jsx';


var url_leidas = "https://2dmtiaujne.execute-api.us-east-2.amazonaws.com/demo/dynamodbmanager/getlectureresultsbyuser/month?userid="

function formatDateTime(datetimeString) {
    const date = new Date(datetimeString);
    // Options for formatting date and time
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };

    return date.toLocaleDateString('es-ES', options);
}

function calcularPuntajeYLecturas(da_leidas) {
    // Paso 1: Agrupar por lecture_id
    const groupedByLecture = da_leidas.reduce((acc, curr) => {
        const { lecture_id, cantidad_acertadas } = curr;
        if (!acc[lecture_id]) {
            acc[lecture_id] = [];
        }
        acc[lecture_id].push(cantidad_acertadas);
        return acc;
    }, {});

    // Paso 2: Calcular el promedio por lecture_id
    const averageByLecture = Object.values(groupedByLecture).map(aciertos => {
        const sum = aciertos.reduce((a, b) => a + b, 0);
        return sum / aciertos.length;
    });

    // Paso 3: Sumar los promedios para obtener el puntaje total
    const puntajeTotal = averageByLecture.reduce((a, b) => a + b, 0).toFixed(2);

    // Paso 4: Contar la cantidad de lecturas distintas (por lecture_id)
    const cantidadLecturasDistintas = Object.keys(groupedByLecture).length;

    // Retornar ambos valores
    return {
        puntajeTotal,
        cantidadLecturasDistintas
    };
}


function Cards({grado_estudiante,categoria_usuario,username}) {
    const [iniciando, setIniciando] = useState(true); // Estado para almacenar los elementos
    const [dataleida, setDataleida] = useState(null); // Estado para almacenar los elementos
    const [data_lecturas_leidas, setData_lecturas_leidas] = useState([]); // Estado para almacenar los elementos

    const [data, setData] = useState([]);

    const [visibleItems, setVisibleItems] = useState(20);

    const [activeSection, setActiveSection] = useState('cards');


    const loadMoreItems = () => {
        setVisibleItems((prev) => prev + 20); // Añadir 20 elementos más cada vez que se scrollea
    };

    useEffect(() =>  {
        async function sacaDatos(iniciando){
            if(iniciando){
                try {

                    //
                    const fechaActual = new Date();
                    const yyyy = fechaActual.getFullYear();
                    const MMMM = String(fechaActual.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11, por eso sumamos 1
                    const fechaFormateada = `${yyyy}_${MMMM}`;
                    //
                    console.log(url_leidas+username+'&month='+fechaFormateada)
                    const response = await fetch(url_leidas+username+'&month='+fechaFormateada);
              
                    //const data = await response.json();
                    var datar = await response.json()
                    var data_lecturas_leidas_old = JSON.parse(datar[0].body).Items
                    console.log("................")
                    setDataleida(datar)
                    setData_lecturas_leidas(data_lecturas_leidas_old)

                    setIniciando(false);
          
                } catch (error) {
                    console.error('Error al obtener registros de lecturas leidas:', error);
                } finally {
                        setIniciando(false);
                }
            }
        }
        sacaDatos(iniciando);
    }, []);

    useEffect(() => {
        var url = ''
        if(grado_estudiante<=6)
            url = `https://img-dinoblanco-shs.s3.amazonaws.com/c/p/${grado_estudiante}/lecturas.json`
        else
            url = `https://img-dinoblanco-shs.s3.amazonaws.com/c/s/${parseInt(grado_estudiante,10)-6}/lecturas.json`
    
        const fetchData = async () => {
          try {
            const response = await fetch(url); // Reemplaza con tu URL
            const jsonData = await response.json();
            setData(jsonData);
          } catch (error) {
            console.error('Error fetching public JSON:', error);
          }
        };
        fetchData();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
          // Detectar si el usuario ha llegado al final de la página (90% del scroll)
          if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight * 0.9) {
            loadMoreItems();
            /* if(dataleida != null){
                if(data.length >= visibleItems)
                    loadMoreItems();
            }else{
                console.log(visibleItems,data.length)
                console.log("YA NO HAY MÁS")
            } */
            
          }
    };

    window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    let resultado = {}
    var puntajeTotal = 0
    var cantidadLecturasDistintas = 0
    let transformedLectures = []
    let myReadingData = []

    if(dataleida != null){
        if( data.slice(0, visibleItems).filter(lectura => !data_lecturas_leidas.some(leida => leida.lecture_id === lectura.id)).length < 10  ){
        //if( data.filter(lectura => lectura.tematica.includes('ugelsihuas')).length < 10){
            console.log(visibleItems)
            //console.log(data)
            console.log("++++++++++++++++++++++++++++++++++++")
            //console.log(data.filter(lectura => lectura.tematica.includes('ugelsihuas')))
            //fetchItems();
            if(data.length > visibleItems)
            loadMoreItems();
            console.log("{}{}{}{}{}{}{}{}{}{}{}{}{}{}{}{}{}{}")
        }

        resultado = calcularPuntajeYLecturas(data_lecturas_leidas);
        puntajeTotal = resultado.puntajeTotal
        cantidadLecturasDistintas = resultado.cantidadLecturasDistintas
        var _transformedLectures = data_lecturas_leidas;
        _transformedLectures.sort((a, b) => new Date(b.datetime_exam) - new Date(a.datetime_exam));
        transformedLectures = _transformedLectures

        const now = new Date();           // Fecha de "hoy"
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth(); // Enero = 0, Febrero = 1, etc.
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        function zeroPad(num) {
            return num.toString().padStart(2, '0');
          }
          var daysArray = [];
        

            console.log(transformedLectures)

            function getAllDaysInMonth(year, month) {
                const days = [];
                const date = new Date(year, month, 1); // Primer día del mes
            
                while (date.getMonth() === month) {
                days.push(`${date.getFullYear()}-${zeroPad(date.getMonth() + 1)}-${zeroPad(date.getDate())}`);
                date.setDate(date.getDate() + 1);
                }
            
                return days;
            }

            function processLectures(lectures) {
                const dayMap = {};
            
                lectures.forEach(lecture => {
                const lectureDate = new Date(lecture.datetime_exam);
                const dateString = `${lectureDate.getFullYear()}-${zeroPad(lectureDate.getMonth() + 1)}-${zeroPad(lectureDate.getDate())}`;
            
                if (!dayMap[dateString]) {
                    dayMap[dateString] = {};
                }
                
                if(lecture.total_preguntas > 0){

                    const lectureId = lecture.lecture_id;
                    const score = lecture.cantidad_acertadas / lecture.total_preguntas;
                
                    if (!dayMap[dateString][lectureId]) {
                        dayMap[dateString][lectureId] = { scores: [], avgScore: 0 };
                    }
                
                    dayMap[dateString][lectureId].scores.push(score);

                }
                
                });
          
            // Calcular promedios por lectura y luego el promedio diario
            let processedDays = Object.entries(dayMap).map(([date, lectures]) => {
              let totalScore = 0;
              let totalLectures = 0;
          
              Object.entries(lectures).forEach(([lectureId, data]) => {
                const avgScore = data.scores.reduce((sum, s) => sum + s, 0) / data.scores.length;
                data.avgScore = avgScore;
                totalScore += avgScore;
                totalLectures++;
              });
          
              return {
                date,
                total_lectures: totalLectures,
                avg_daily_score: totalLectures > 0 ? totalScore / totalLectures : 0
              };
            });
          
            // Obtener todas las fechas del mes actual
            const today = new Date();
            const allDays = getAllDaysInMonth(today.getFullYear(), today.getMonth());
          
            // Llenar las fechas faltantes con valores por defecto (0)
            const fullMonthData = allDays.map(date => {
              const existingDay = processedDays.find(d => d.date === date);
              return existingDay || { date, total_lectures: 0, avg_daily_score: 0 };
            });
          
            return fullMonthData;
          }
          daysArray = processLectures(transformedLectures)
          //console.log(processLectures(transformedLectures));
          myReadingData = daysArray
        
    }
    console.log(".#.#:#.#.#.#:#.#.#.#.3")
    console.log(data)

    /* const literaturaFilter = ["cuento", "litera", "mito", "leyend", "cultura", "religi", "arte", "lenguaje"];
    const cienciaYtechFilter = ["ciencia", "science", "física", "química", "quimica", "fisica","natur"];
    const cienciasSocialesFilter = ["historia", "econom", "cívic", "civic"];


    const arteYCulturaFilter = ["arte", "cultura"];
    const desarrolloPersonalFilter = ["motivaci", "desarroll", "maestr", "enseñanz", "personal","cívic", "civic"];
    const idiomasFilter = ["ingl", "quechua", "idiom", "aymar", "english"];
    const matematicasFilter = ["matemát","matemat","geometr","trigonom","aritm","algebr","álgebr"];
    const educacionFisicaFilter = ["deporte", "educación física","educacion fisica","educacion física","educación fisica"];
    const edTrabajoFilter = ["manualid","origami", "trabajo"];
    const religionFilter = ["religi", "meditaci"];

    const tutoriaFilter = ["biograf", "valores", "motivaci", "desarroll", "maestr", "enseñanz", "personal"];
    const cardPdfFilter = ["pdf"]; */

    const literaturaFilter = [
        "cuento", "litera", "mito", "leyend", "cultura", "cultur", "religi", "religion", "arte", 
        "lenguaj", "lenguaje", "comunica", "comunicacion", "gram", "gramat", "ortograf", "ortografia", 
        "comprensi", "comprension", "redacci", "redaccion", "narrat", "narrativa", "poes", "poesia", 
        "vers", "verso", "rima", "literari", "literario"
      ];
      
    const cienciaYtechFilter = [
        "ciencia", "science", "fisic", "fisica", "quimic", "quimica", "natur", "naturaleza", 
        "ambient", "ambiente", "tecnolog", "tecnologia", "energ", "energia", "materi", "materia", 
        "ecos", "ecosistema", "biodivers", "biodiversidad", "investigac", "investigacion", 
        "biolog", "biologia", "astro", "astronomia", "nanotec", "nanotecnologia", "ingenier", 
        "ingenieria", "robot", "robotica", "inteligencia artificial"
        ];
    
    const cienciasSocialesFilter = [
        "histori", "historia", "econom", "economia", "civic", "civica", "geograf", "geografia", 
        "politic", "politica", "política", "sociolog", "sociologia", "antropolog", "antropologia", 
        "democrac", "democracia", "globalizac", "globalizacion", "derech", "derecho", 
        "justic", "justicia", "socied", "sociedad"
        ];
    
    const arteYCulturaFilter = [
        "arte", "cultura", "cultur", "music", "musica", "pintur", "pintura", "color", 
        "teatr", "teatro", "instrument", "instrumento", "danz", "danza", "gastronom", 
        "gastronomia", "identidad", "escultur", "escultura", "fotograf", "fotografia", 
        "cinematograf", "cinematografia", "arquitect", "arquitectura"
        ];
    
    const desarrolloPersonalFilter = [
        "motivac", "motivacion", "desarroll", "desarrollo", "maestr", "maestria", "enseñanz", 
        "enseñanza", "ensenanz", "ensenanza", "personal", "civic", "civica", "higien", 
        "higiene", "autoestima", "identidad", "superacion", "superación", "emocion", 
        "emocion", "resilienc", "resiliencia", "liderazg", "liderazgo", "habilidades", "habilidad"
        ];
    
    const idiomasFilter = [
        "ingl", "ingles", "quechua", "idiom", "idioma", "aymar", "aymara", "english", "franc", 
        "frances", "portugu", "portugues", "italian", "italiano", "chino", "japon", 
        "japones", "alem", "aleman", "biling", "bilingue"
        ];
    
    const matematicasFilter = [
        "matemat", "matematicas", "matemát", "matemáticas", "geometr", "geometria", "trigonom", 
        "trigonometria", "aritm", "aritmetica", "algebr", "algebra", "álgebr", "álgebra", 
        "estadist", "estadistica", "probabil", "probabilidad", "ecuacion", "ecuaciones", 
        "calcul", "cálculo", "fraccion", "fracciones", "funcion", "funciones"
        ];
    
    const educacionFisicaFilter = [
        "deport", "deporte", "educacion fisica", "educación física", "salud", "alimentac", 
        "alimentacion", "nutric", "nutricion", "ejercici", "ejercicio", "bienestar", 
        "entren", "entrenamiento", "resistenc", "resistencia", "fuerz", "fuerza"
        ];
    
    const edTrabajoFilter = [
        "manualid", "manualidades", "origam", "origami", "trabaj", "trabajo", "liderazg", 
        "liderazgo", "innovac", "innovacion", "tecnolog", "tecnologia", "equip", "equipo", 
        "software", "emprended", "emprendimiento", "proyect", "proyecto", "industr", "industria"
        ];
    
    const religionFilter = [
        "religi", "religion", "meditac", "meditacion", "espirit", "espiritual", "oracion", 
        "oraciones", "fe", "valores", "creenc", "creencias"
        ];
    
    const tutoriaFilter = [
        "biograf", "biografia", "valores", "motivac", "motivacion", "desarroll", "desarrollo", 
        "maestr", "maestria", "enseñanz", "enseñanza", "ensenanz", "ensenanza", "personal", 
        "autoestima", "habilidades", "habilidad", "psicolog", "psicologia", "autoconoc", "autoconocimiento"
        ];
    
    const cardPdfFilter = ["pdf"];
    
    const datosCuriososFilter = [
        "curios", "curioso", "curiosidad", "sorpren", "sorprendente", "extrañ", "extraño", 
        "insólit", "insolito", "rar", "raro", "relev", "relevante", "interes", "interesante", 
        "asombros", "asombroso", "increíbl", "increible", "impact", "impactante", "inesper", 
        "inesperado", "fascin", "fascinante", "misterios", "misterioso", "extraordin", 
        "extraordinario", "únic", "unico", "peculi", "peculiar", "inusual", "desconcert", 
        "desconcertante", "exót", "exotico", "notabl", "notable", "llamat", "llamativo", 
        "significativ", "significativo", "memorabl", "memorable", "impresion", "impresionante"
        ];
    
    const cardCensoNacional = ["censonacional", "censo", "test", "exam"];
    
    return (
        dataleida != null?
                <div className="w-full py-0 px-3 ">

                    <HeaderResults myReadingData={myReadingData} data={transformedLectures} username={username}> </HeaderResults>


                    <div className="mt-3 mb-6">
                        {/* Mensaje llamativo */}
                        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 px-4 py-1 rounded-md shadow-lg ">
                            <h2 className="text-2xl font-bold">¡Refuerza tus lecturas!</h2>

                            <div className="flex space-x-4 overflow-x-auto scrollbar-hide py-2">
                                {
                                    transformedLectures.map(card => {
                                    return (
                                        <CardHistoryItem
                                        title={card.lecture_id.split("-")[0]}
                                        image={`https://img-dinoblanco-shs.s3.amazonaws.com/album/${card.lecture_id}.jpg`}
                                        aciertos={card.cantidad_acertadas}
                                        preguntas={card.total_preguntas}
                                        fecha={formatDateTime(card.datetime_exam)}
                                        lecture_id = {card.lecture_id}
                                        />
                                    )})
                                }
                            </div>
                        </div>
                        
                    </div>

                    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 px-2 py-0 rounded-md shadow-lg ">
                        
                        <h2 className="text-2xl font-bold m-0">¡Explora Leyendo!</h2>
                        <LectureCategorySelector onClickActive={setActiveSection}></LectureCategorySelector>
                        

                        {/* Contenido dinámico según la sección seleccionada */}
                        <div className="p-2">


                            {activeSection === 'cards' && (
                                <CardGrid data={data} visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'pdfGrid' && (
                                
                                <PDFGrid 
                                    data={
                                        data.filter(lectura =>
                                            cardPdfFilter.some(palabra =>
                                              (lectura.tipomated || '').toLowerCase().includes(palabra.toLowerCase())
                                            )
                                          
                                    )}
                                    visibleItems={visibleItems} />
                            )}
                            {activeSection === 'cardsLiteratura' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        literaturaFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsTechSciences' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        cienciaYtechFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsSocialSciences' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        cienciasSocialesFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsArtAndCulture' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        arteYCulturaFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsPersonalDevelop' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        desarrolloPersonalFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsIdioms' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        idiomasFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsMath' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        matematicasFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsSport' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        educacionFisicaFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsManualidades' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        edTrabajoFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsReligion' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        religionFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsTutoria' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        tutoriaFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsDatosCuriosos' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        datosCuriososFilter.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {activeSection === 'cardsCensoNacional' && (
                                <CardGrid data={
                                    data.filter(lectura =>
                                        cardCensoNacional.some(palabra =>
                                          lectura.tematica.toLowerCase().includes(palabra.toLowerCase())
                                        )
                                      )
                                } 
                                visibleItems={visibleItems} data_lecturas_leidas={data_lecturas_leidas}></CardGrid>
                            )}
                            {/* Aquí podrías agregar más condiciones para otras secciones */}
                        </div>
                    </div>
                </div>                
        :
        <Loader></Loader>
    );
    
}

export default Cards